var _rect, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToggleActve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 147,
    viewBox: "0 0 265 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 146.177,
    rx: 73.0887,
    fill: "#595959"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 197.125,
    cy: 72.6182,
    r: 57.7429,
    fill: "white",
    stroke: "url(#paint0_linear_7188_18692)",
    strokeWidth: 0.514286
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7188_18692",
    x1: 139.125,
    y1: 14.6182,
    x2: 139.125,
    y2: 130.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    stopOpacity: 0.0252353
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggleActve);
export default __webpack_public_path__ + "static/media/icon-toggle-actve.a28c81fd50b5a7acc12a7d3c57b47c13.svg";
export { ForwardRef as ReactComponent };